// extracted by mini-css-extract-plugin
module.exports = {"floatAd":"floatAd-2yTS-3vV"};